// @ts-nocheck
import _ from 'lodash';
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { makeStyles, Box } from '@material-ui/core';
import { EmptyState } from '../../../../../common/components';
import ActivityList from '../common/ActivityList';
import ActivityCard from '../common/ActivityCard';

const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    height: '100%',
  },
  column: {
    flex: '1',
    padding: theme.spacing(4),
  },
}));

function ShowsTab(props) {
  const [t] = useTranslation();
  const classes = useStyles();

  const { activities, playbacks } = props;

  const filteredActivities = useMemo(
    () => _.filter(activities, activity => !_.isEmpty(activity.presentationTitle)),
    [activities]
  );

  const filteredPlaybacks = useMemo(
    () => _.filter(playbacks, playback => !_.isEmpty(playback.presentationTitle)),
    [playbacks]
  );

  return (
    <Box id="ShowsTab-container" className={classes.container}>
      {_.isEmpty(filteredActivities) && _.isEmpty(filteredPlaybacks) ? (
        <EmptyState variant="empty" message={t('activity.showsEmpty')} />
      ) : (
        <>
          <Box className={classes.column}>
            <ActivityList
              id="ShowsTab-started"
              title={t('activity.showsStarted')}
              activities={filteredActivities}
              renderActivity={(activity, activityId) => (
                <ActivityCard
                  activityId={activityId}
                  title={activity.presentationTitle}
                  subtitle={activity.presentationSubtitle || activity.title}
                  imageUrl={activity.imageUrl}
                  description={activity.description}
                  position={activity.position}
                  duration={activity.duration}
                  type={activity.type}
                  started={activity.created}
                  lastViewed={activity.modified}
                  profile={activity.profileName}
                />
              )}
              emptyContent={<EmptyState message={t('activity.showsStartedEmpty')} center={false} />}
            />
          </Box>
          <Box className={classes.column}>
            <ActivityList
              id="ShowsTab-historical"
              title={t('activity.showsHistorical')}
              activities={filteredPlaybacks}
              renderActivity={(activity, activityId) => (
                <ActivityCard
                  activityId={activityId}
                  title={activity.presentationTitle}
                  subtitle={activity.presentationSubtitle || activity.title}
                  imageUrl={activity.imageUrl}
                  description={activity.description}
                  type={activity.type}
                  lastViewed={activity.viewedAt}
                  profile={activity.profileName}
                />
              )}
              emptyContent={
                <EmptyState message={t('activity.showsHistoricalEmpty')} center={false} />
              }
            />
          </Box>
        </>
      )}
    </Box>
  );
}

ShowsTab.propTypes = {
  activities: PropTypes.arrayOf(PropTypes.object).isRequired,
  playbacks: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default ShowsTab;
